'use strict'

import AbstractState from '@/ghost/workflow/payment/state/AbstractState'

export default class PaymentProcessedState extends AbstractState {}
